import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';

import messages from './messages';
import styles from './styles';

const OrderTitle = ({
    classes,
    order: {
        BookingOrderNumber,
        BookingOrderStatus,
        BookingOrderDetailsHoldExpiration,
        BookingOrderCancelInfo: {
            BookingOrderCancelInfoCanceledDate,
            BookingOrderCancelInfoCancellationReason,
            BookingOrderInternalCancellationReason,
            BookingOrderInternalCancellationDelayedRefundAvailableAtDesc,
        },
    },
    intl: { formatMessage },
}) => {
    const bookingCancelStatus = {
        CANCELED_WITH_FRAUD_PENALTY: {
            message: messages.CANCELED_WITH_FRAUD_PENALTY,
        },
        DELAY_CANCEL: {
            message: {
                ...messages.DELAY_CANCEL,
                values: {
                    refundAvailable: BookingOrderInternalCancellationDelayedRefundAvailableAtDesc,
                },
            },
        },
        CANCELED: {
            message: messages.CANCELED_FRAUD_NOT_FOUND,
        },
        RELEASE_SEAT: {
            message: messages.RELEASE_SEAT,
        },
    }[BookingOrderInternalCancellationReason];
    const bookingCancelInfoStatus = {
        VOID_EXCEPTION: {
            message: messages.VOID_EXCEPTION,
        },
    }[BookingOrderCancelInfoCancellationReason];

    const getInternalCancellationReasonTitleMessage = () => {
        let returnMessage;
        if (['RELEASED', 'ABANDONED', 'CANCELED', 'REPLACED', 'WITHDRAWN'].includes(BookingOrderStatus)
            && BookingOrderInternalCancellationReason === 'RELEASE_SEAT') {
            returnMessage = <FormattedMessage {...messages.RELEASE_SEAT_NORMAL} />;
        } else if (BookingOrderStatus === 'RETURNED' && BookingOrderInternalCancellationReason === 'RELEASE_SEAT') {
            returnMessage = <FormattedMessage {...messages.RELEASE_SEAT_RETURNED} />;
        } else if (BookingOrderInternalCancellationReason === 'RELEASE_SEAT') {
            returnMessage = <FormattedMessage {...messages.RELEASE_SEAT} />;
        } else {
            returnMessage = <FormattedMessage {...bookingCancelStatus.message} />;
        }
        return returnMessage;
    };
    return (
        <>
            <b className={classes.orderTitle}>
                <FormattedMessage {...messages.lblOrderNumber} values={{ index: BookingOrderNumber }} />
            </b>
            <span className={classes.orderSubtitle}>
                <FormattedMessage {...messages[BookingOrderStatus]} />
                {BookingOrderStatus === 'BOOKED' && (
                    <>
                        {' '}
                        <FormattedMessage
                            {...messages.lblOrderConfirmBy}
                            values={{ date: BookingOrderDetailsHoldExpiration.replace('&nbsp;', ' ') }}
                        />
                    </>
                )}
                {!!BookingOrderCancelInfoCanceledDate && (!!bookingCancelInfoStatus || !!BookingOrderCancelInfoCancellationReason) && (
                    <>
                        {' '}
                        <FormattedMessage
                            {...messages.lblCancellationReason}
                            values={{
                                reason: bookingCancelInfoStatus
                                    ? formatMessage(bookingCancelInfoStatus.message)
                                    : BookingOrderCancelInfoCancellationReason,
                                date: BookingOrderCancelInfoCanceledDate,
                            }}
                        />
                    </>
                )}
                {bookingCancelStatus && (
                    <>
                        {': '}
                        <span className={classes.fraudDetected}>
                            {getInternalCancellationReasonTitleMessage()}
                        </span>
                    </>
                )}
            </span>
        </>
    );
};

OrderTitle.propTypes = {
    classes: PropTypes.object.isRequired,
    order: PropTypes.object.isRequired,
    intl: PropTypes.object,
};

export { OrderTitle as OrderTitleAlias };

export default injectIntl(withStyles(styles)(OrderTitle));
